<template>
  <div>
    <div style="display:flex; justify-content:space-between; width:100%; height:50px; box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 10%); border-radius:8px; padding:10px; margin-bottom:5px;">
      <div style="display:flex">
        <vs-button color="primary" type="flat" style="width:80px; font-size: 15px; padding:0 5px; text-align:center; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" @click="showExam(examInfo)"><strong>{{examTitle(examInfo).test_name}}</strong></vs-button>
        <div style="width:40px; height: 30px; background: #ffe998; border-radius:5px; padding:5px; text-align:center; font-weight:bold">
          {{grade}}
        </div>
        <div style="width:150px; margin-left:10px; font-weight:bold; padding:5px 0;">
          <p v-if="examInfo.people_num != null">시험 참여수 : {{examInfo.people_num}}</p>
          <p v-if="examInfo.people_num == null">시험 참여수 : 0</p>
        </div>
      </div>
      <div style="display:flex">
        <vs-button color="#ff0000" @click="deleateExamList(examInfo)" style="margin-right:3px;" type="border" icon-pack="feather" size="small" icon="icon-x"></vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EditIcon,
  XIcon
} from 'vue-feather-icons'
export default {
  props:['examInfo'],
  components: {
    EditIcon,
    XIcon
  },
  data() {
    return {
      grade : ''
    }
  },
  created() {
    console.log(this.examInfo)
  },
  methods: {
    showExam(val) {
      var index = this.allExamList.findIndex((item)=> {
        return item.id == val.exam_id
      })
      console.log(index)
      this.$store.commit('etest/ACTIVE_EXAML' , this.allExamList[index])
      this.$router.push('/apps/etest/editer/0')
    },
    deleateExamList(val) {
      this.$emit('delete' , val)
    },
    examTitle(val) {
        var index = this.allExamList.findIndex((item)=> {
          return item.id == val.exam_id
        })
      var list = this.allExamList[index]
      if(list.grade == 1 && list.info == 'high') {
        this.grade = '고1'
      }
      if(list.grade == 2 && list.info == 'high') {
        this.grade = '고2'
      }
      if(list.info == 'sat') {
        this.grade = '수능'
      }
      return this.allExamList[index]
    }
  },
  computed: {
    allExamList() {
      return this.$store.state.etest.allExamList
    },
  }
}
</script>

<style>
  .edit_btn:hover {
    cursor:pointer
  }
  .delete_btn:hover {
    cursor: pointer
  }
</style>
